export const createOffer = {
  // ── Page / Breadcrumb ──────────────────────────────────────────────────────
  CO_PAGE_TITLE:              'Create Customer Offer',
  CO_OFFER_NO_LABEL:          'Offer No.',
  CO_HEADER_EYEBROW:          'New Document',
  CO_PAGE_SUBTITLE:           'On this page, you can create a customer offer by adding the customer, the offered service, compensation, and a review & signature — all in one place.',

  // ── Stepper ────────────────────────────────────────────────────────────────
  CO_STEP_COMPANY_LOGO:              'Company Logo',
  CO_STEP_PARTIES_INFO:              'Customer & Offer Details',
  CO_STEP_ASSIGNMENT_COMPENSATION:   'Assignment & Compensation',
  CO_STEP_LEGAL_SIGNATURES:          'Legal & Signatures',
  CO_STEP_COMPANY_LOGO_SUB:            'Brand the document',
  CO_STEP_PARTIES_INFO_SUB:            'Who is this for',
  CO_STEP_ASSIGNMENT_COMPENSATION_SUB: 'Scope & payment',
  CO_STEP_LEGAL_SIGNATURES_SUB:        'Review & sign',

  // ── Step 0 — Company Logo & Profile ──────────────────────────────────────────
  CO_LOGO_CARD_TITLE:         'Company Logo',
  CO_LOGO_CARD_SUBTITLE:      'Upload your company logo to personalise the customer offer document.',
  CO_LOGO_NO_LOGO:            'No company logo uploaded',
  CO_LOGO_CHANGE_IN_SETTINGS: 'Change Logo in Profile Settings',
  CO_LOGO_SETTINGS_NOTE:      'Your company logo is configured in your profile settings and will appear on all documents.',
  CO_INVOZIO_INFO_TITLE:      'Invozio Information',
  CO_INVOZIO_INFO_COMPANY:    'Invozio LV SIA',
  CO_INVOZIO_INFO_REG:        '502085-4062',
  CO_INVOZIO_INFO_REF:        '(Referred to below as "Invozio")',
  CO_PREFERRED_LANGUAGE_LABEL:   'Preferred language',
  CO_PREFERRED_LANGUAGE_HINT:    'The language this offer (and its document/email) will be created in. Defaults to your platform language the first time, then remembers your last choice.',

  // ── Step 1 — Customer & Offer Details ────────────────────────────────────────
  CO_CUSTOMER_CARD_TITLE:        'Customer Information',
  CO_CUSTOMER_ADD_CUSTOMER:      'Add New Customer',
  CO_CUSTOMER_SELECT_LABEL:      'Select existing customer:',
  CO_CUSTOMER_SELECT_PLACEHOLDER: 'Select customer',
  CO_CUSTOMER_REMOVE_CUSTOMER:   'Remove',
  CO_CUSTOMER_NO_CUSTOMERS:      'Customer not found',
  CO_CONTACT_PERSON_LABEL:       'Contact Person',
  CO_CONTACT_PERSON_HINT:        'Enter the contact person\'s name',
  CO_CONTACT_PHONE_LABEL:        'Contact Phone',
  CO_CONTACT_PHONE_HINT:         'Enter a phone number',
  CO_OFFERED_SERVICES_LABEL:     'Offered Service Name',
  CO_OFFERED_SERVICES_HINT:      'e.g. Consulting services',
  CO_WORK_DESC_LABEL:            'Service Description',
  CO_WORK_DESC_HINT:             'Describe what this offer includes',

  // ── Step 2 — Assignment & Compensation ───────────────────────────────────────
  CO_ASSIGN_PERIOD_TITLE:        'Offer Period',
  CO_ASSIGN_PERIOD_LABEL:        'Assignment Period',
  CO_ASSIGN_PERIOD_HINT:         'e.g. Ongoing',
  CO_ASSIGN_START_DATE:          'Start date',
  CO_ASSIGN_END_DATE:            'End date',
  CO_DATE_PLACEHOLDER:           'yyyy/mm/dd',
  CO_ASSIGN_NO_END_DATE:         'No end date',
  CO_ASSIGN_NO_END_DATE_INFO:    'Check this if the assignment continues indefinitely with no fixed end date.',
  CO_ASSIGN_NOTICE_CHECKBOX:     'Notice period',
  CO_ASSIGN_NOTICE_INFO:         'Check this if either party must give advance notice before ending the assignment early.',
  CO_ASSIGN_NOTICE_LABEL:        'Notice period',
  CO_ASSIGN_NOTICE_1M:           '1 month',
  CO_ASSIGN_NOTICE_2M:           '2 months',
  CO_ASSIGN_NOTICE_3M:           '3 months',
  CO_ASSIGN_NOTICE_6M:           '6 months',
  CO_ASSIGN_NOTICE_HINT:         'Customer must be notified this long before the offer end date.',
  CO_ASSIGN_DESC_TITLE:          'Assignment Description',
  CO_ASSIGN_DESC_LABEL:          'Describe the services and deliverables that will be provided under this offer.',
  CO_ASSIGN_DESC_HINT:           'Enter a detailed description of the assignment...',
  CO_SPECIAL_TERMS_LABEL:        'Special terms:',
  CO_SPECIAL_TERMS_HINT:         'Enter any special terms or conditions...',
  CO_COMP_TITLE:                 'Compensation Details',
  CO_COMP_TYPE_LABEL:            'Compensation type',
  CO_COMP_TYPE_PLACEHOLDER:      'Select type',
  CO_COMP_TYPE_PER_HOUR:         'Payment per hour',
  CO_COMP_TYPE_PER_DAY:          'Payment per day',
  CO_COMP_TYPE_PER_WEEK:         'Payment per week',
  CO_COMP_TYPE_PER_MONTH:        'Payment per month',
  CO_COMP_TYPE_AS_AGREED:        'Fixed price',
  CO_COMP_TYPE_PER_UNIT:         'Payment per unit',
  CO_COMP_UNIT_LABEL:            'Number of units',
  CO_COMP_UNIT_HINT:             'e.g. 10',
  CO_COMP_CURRENCY_LABEL:        'Currency',
  CO_COMP_AMOUNT_LABEL:          'Amount',
  CO_COMP_AMOUNT_HINT:           'Enter amount',
  CO_COMP_INVOICE_NOTE:          'Invoicing for work performed will be issued on a monthly basis. A 30-day payment term applies. A reminder fee of 60 SEK and a collection fee of 180 SEK are currently applicable, or the amounts otherwise stipulated by law. Late payment interest will also apply.',

  // ── Step 3 — Legal & Signatures ────────────────────────────────────────────
  CO_LEGAL_CARD_TITLE:               'Legal Terms & Conditions',
  CO_LEGAL_TAXES_HEADING:            'Taxes and Fees',
  CO_LEGAL_TAXES_BODY:               'The compensation is exclusive of VAT. Invozio is solely responsible for payroll administration, tax withholdings, social security contributions, and other statutory obligations related to the Service Provider. Upon reasonable request, Invozio shall provide evidence of compliance.',
  CO_LEGAL_INSURANCE_HEADING:        'Insurance',
  CO_LEGAL_INSURANCE_BODY:           'Invozio maintains insurance coverage in accordance with its insurance policies in force from time to time. Coverage is subject to the terms, conditions, exclusions and limitations of the applicable insurance policies.',
  CO_LEGAL_CONFIDENTIALITY_HEADING:  'Confidentiality',
  CO_LEGAL_CONFIDENTIALITY_BODY:     'The freelancer and Invozio undertake not to disclose confidential information obtained through the assignment except as required by law or for the administration of the assignment.',
  CO_LEGAL_ROLE_HEADING:             'Service Provider Responsibility',
  CO_LEGAL_ROLE_BODY:                "The Services are performed by an independent Service Provider engaged through Invozio. The Service Provider is solely responsible for the performance, quality, qualifications, and delivery of the Services. Invozio's role is limited to administrative, invoicing, payroll, insurance, and compliance-related services.",
  CO_LEGAL_LIMITATION_HEADING:       'Limitation of Liability',
  CO_LEGAL_LIMITATION_BODY:          "Invozio's total liability under this Agreement shall not exceed the fees paid by the Customer to Invozio during the twelve (12) months preceding the claim.",
  CO_LEGAL_ACK_HEADING:              'Client Acknowledgement',
  CO_LEGAL_ACK_BODY:                 'The Client acknowledges that all services are provided directly by the Freelancer who bears sole and exclusive responsibility for scope, quality, performance, and delivery of those services.',
  CO_REVIEW_CONFIRM_TEXT:        'I confirm that all information provided for this offer is accurate and complete to the best of my knowledge. I understand that this information will be used to generate the final offer document, and that I am personally responsible for the submitted information and any consequences arising from inaccuracies.',
  CO_SIG_CARD_TITLE:             'Signatures',
  CO_SIG_FREELANCER_LABEL:       'On behalf of the freelancer:',
  CO_SIG_DATE_LABEL:             'Date',
  CO_SIG_SIGNATURE_LABEL:        'Signature',
  CO_SIG_DRAW_BTN:               'Draw Signature',
  CO_SIG_UPLOAD_BTN:             'Upload Signature',
  CO_SIG_CANVAS_HINT_DRAW:       'Draw your signature here',
  CO_SIG_CANVAS_HINT_UPLOAD:     'Your uploaded signature will appear here',
  CO_SIG_CLEAR_BTN:              'Clear',
  CO_SIG_NAME_LABEL:             'Name Clarification',
  CO_SIG_NAME_HINT:              'Enter your full name',
  CO_SIG_PLACE_LABEL:            'Place',
  CO_SIG_INVOZIO_LABEL:          'On behalf of Invozio LV SIA:',
  CO_SIG_INVOZIO_PRE_SIGNED:     'Digitally pre-signed',
  CO_SIG_CUSTOMER_LABEL:         'On behalf of the customer:',
  CO_SIG_CUSTOMER_PENDING_BADGE: 'Awaiting response',
  CO_SIG_CUSTOMER_SIGNED_BADGE:  'Signed',
  CO_SIG_CUSTOMER_PENDING_BODY:  'The customer will accept or decline after you send this offer.',
  CO_SIG_CUSTOMER_PLACEHOLDER_NAME: 'Customer',

  // ── Footer actions ─────────────────────────────────────────────────────────
  CO_BTN_CANCEL:      'Cancel',
  CO_BTN_BACK:        'Back',
  CO_BTN_NEXT:        'Next',
  CO_BTN_SAVE_DRAFT:  'Save as Draft',
  CO_BTN_SAVING_DRAFT: 'Saving…',
  CO_BTN_SEND_OFFER:  'Review and Send',
  CO_BTN_SENDING:     'Sending…',

  // ── Validation messages ────────────────────────────────────────────────────
  CO_VAL_FIELD_REQUIRED:      'This field is required.',
  CO_VAL_CUSTOMER_REQUIRED:   'Please select a customer.',
  CO_VAL_END_DATE_REQUIRED:   "Please set an end date or check 'No end date'.",
  CO_VAL_END_AFTER_START:     'End date must be after the start date.',
  CO_VAL_AMOUNT_POSITIVE:     'Please enter a valid amount greater than 0.',
  CO_VAL_TERMS_REQUIRED:      'Please confirm the acknowledgement to continue.',
  CO_VAL_SIGNATURE_REQUIRED:  'Please provide a signature.',

  // ── Toast messages ─────────────────────────────────────────────────────────
  CO_TOAST_CUSTOMER_REQUIRED: 'Please select a customer before submitting.',
  CO_TOAST_FILL_REQUIRED:     'Please fill in the required fields',
  CO_TOAST_SUCCESS:           'Offer created successfully!',
  CO_TOAST_ERROR:             'Failed to create offer. Please try again.',
  CO_TOAST_UPDATE_SUCCESS:    'Offer updated successfully!',
  CO_TOAST_UPDATE_ERROR:      'Failed to update offer. Please try again.',
  CO_TOAST_LOAD_ERROR:        'Failed to load the offer. Please try again.',
  CO_TOAST_SEND_SUCCESS:      'Offer saved and sent to the customer!',
  CO_TOAST_SEND_ERROR:        'Failed to send the offer to the customer. Please try again.',
  CO_TOAST_SEND_LOOKUP_ERROR: 'Offer was saved, but it could not be sent automatically. Please send it from the offers list.',

  // ── Send-offer preview modal ───────────────────────────────────────────────
  CO_PREVIEW_MODAL_TITLE:    'Review before sending',
  CO_PREVIEW_MODAL_SUBTITLE: 'Preview the offer exactly as your customer will receive it.',
  CO_PREVIEW_SEND_TO:        'This offer will be sent to {{name}} ({{email}}).',
  CO_PREVIEW_SWIPE_UP:       'Swipe up',
  CO_PREVIEW_SWIPE_DOWN:     'Swipe down',
  CO_PREVIEW_DOWNLOAD:       'Download PDF',
  CO_BTN_CONFIRM_SEND:       'Send to Customer',

  // ── Edit mode ──────────────────────────────────────────────────────────────
  CO_PAGE_TITLE_EDIT: 'Edit Customer Offer',
  CO_BTN_UPDATE:      'Update',
  CO_BTN_UPDATING:    'Updating…',
  CO_LOADING_OFFER:   'Loading offer…',

  // ── Offers grid ─────────────────────────────────────────────────────────────
  COG_TITLE:             'Your Offers',
  COG_LOADING:           'Loading offers…',
  COG_ERROR:             'Failed to load offers. Please refresh.',
  COG_EMPTY:             'No offers yet.',
  COG_EMPTY_ARCHIVED:    'No archived offers.',
  COG_CREATE_FIRST:      'Create your first offer',
  COG_BTN_NEW:            'New Offer',
  COG_TAB_ALL:           'All',
  COG_TAB_ARCHIVED:      'Archived',
  COG_COL_OFFER_NO:      'Offer No.',
  COG_COL_CUSTOMER:      'Customer',
  COG_COL_SERVICE:       'Offered Service',
  COG_COL_START_DATE:    'Start Date',
  COG_COL_END_DATE:      'End Date',
  COG_COL_AMOUNT:        'Amount',
  COG_COL_STATUS:        'Status',
  COG_COL_CREATED:       'Created',
  COG_COL_ACTIONS:       'Actions',
  COG_NO_END_DATE:       'No end date',
  COG_STATUS_DRAFT:             'Draft',
  COG_STATUS_PENDING_SIGNATURE: 'Sent/Pending Signature',
  COG_STATUS_ACCEPTED:          'Signed',
  COG_STATUS_EXPIRED:           'Expired',
  COG_STATUS_DECLINED:          'Declined',
  COG_STATUS_CANCELLED:         'Cancelled',
  COG_STATUS_ARCHIVED:          'Archived',
  COG_ACTION_DOWNLOAD_PDF: 'Download PDF',
  COG_ACTION_EDIT:         'Edit Offer',
  COG_ACTION_EDIT_DISABLED: 'Only draft offers can be edited',
  COG_ACTION_EDIT_DISABLED_ARCHIVED: 'Archived offers cannot be edited',
  COG_DOWNLOAD_SUCCESS:    'PDF downloaded successfully.',
  COG_DOWNLOAD_ERROR:      'Failed to download PDF. Please try again.',
  COG_ACTION_SEND:                    'Send to customer',
  COG_ACTION_SEND_DISABLED_ARCHIVED:  'Archived offers cannot be sent',
  COG_ACTION_SEND_DISABLED_EXPIRED:   'Expired offers cannot be sent. Duplicate it to create a new version.',
  COG_ACTION_SEND_DISABLED_ACCEPTED:  'This offer has already been signed and cannot be sent again.',
  COG_ACTION_SEND_DISABLED_DECLINED:  'This offer was declined and cannot be sent again. Duplicate it to create a new version.',
  COG_ACTION_SEND_DISABLED_CANCELLED: 'Cancelled offers cannot be sent.',
  COG_ACTION_DUPLICATE:   'Duplicate / Create new version',
  COG_SEND_NO_EMAIL:      'This customer has no email address on file.',
  COG_SEND_SUCCESS:       'Offer emailed successfully.',
  COG_SEND_ERROR:         'Failed to send the offer email. Please try again.',
  COG_ACTION_ARCHIVE:      'Archive offer',
  COG_ACTION_UNARCHIVE:    'Unarchive offer',
  COG_ARCHIVE_SUCCESS:     'Offer archived successfully.',
  COG_ARCHIVE_ERROR:       'Failed to archive the offer. Please try again.',
  COG_UNARCHIVE_SUCCESS:   'Offer unarchived successfully.',
  COG_UNARCHIVE_ERROR:     'Failed to unarchive the offer. Please try again.',

  // ── Public customer offer accept/decline page ──────────────────────────────
  COSIGN_PAGE_TITLE:           'Customer Offer',
  COSIGN_PAGE_SUBTITLE:        'Please review the offer below before accepting or declining it.',
  COSIGN_LOADING:              'Loading offer…',
  COSIGN_LOAD_ERROR_TITLE:     'This link is no longer valid',
  COSIGN_LOAD_ERROR_BODY:      "We couldn't load this offer. The link may have expired, already been used, or is invalid.",
  COSIGN_PDF_CARD_TITLE:       'Offer Document',
  COSIGN_BTN_ACCEPT:           'Accept Offer',
  COSIGN_BTN_DECLINE:          'Decline',
  COSIGN_SIGN_CARD_TITLE:      'Confirm & Sign',
  COSIGN_SIGNATURE_LABEL:      'Signature',
  COSIGN_CANVAS_HINT:          'Draw your signature here',
  COSIGN_CLEAR_BTN:            'Clear',
  COSIGN_NAME_LABEL:           'Name Clarification',
  COSIGN_NAME_HINT:            'Enter your full name',
  COSIGN_TERMS_CONFIRM_TEXT:   'I have reviewed the offer above and accept its terms and conditions.',
  COSIGN_BTN_CONFIRM_SIGN:     'Confirm & Sign',
  COSIGN_BTN_SIGNING:          'Signing…',
  COSIGN_BTN_CANCEL:           'Cancel',
  COSIGN_DECLINE_CARD_TITLE:   'Decline Offer',
  COSIGN_DECLINE_REASON_LABEL: 'Please tell us why you’re declining this offer:',
  COSIGN_DECLINE_REASON_HINT:  'Enter your reason...',
  COSIGN_BTN_CONFIRM_DECLINE:  'Confirm Decline',
  COSIGN_BTN_DECLINING:        'Declining…',
  COSIGN_VAL_SIGNATURE_REQUIRED: 'Please provide a signature.',
  COSIGN_VAL_NAME_REQUIRED:      'Please enter your full name.',
  COSIGN_VAL_TERMS_REQUIRED:     'Please confirm that you accept the offer.',
  COSIGN_VAL_REASON_REQUIRED:    'Please provide a reason.',
  COSIGN_SIGN_SUCCESS_TITLE:   'Offer accepted',
  COSIGN_SIGN_SUCCESS_BODY:    'Thank you — the offer has been accepted and signed successfully. You may now close this window.',
  COSIGN_SIGN_ERROR:           'Failed to submit your signature. Please try again.',
  COSIGN_BTN_DOWNLOAD:         'Download signed offer',
  COSIGN_BTN_DOWNLOADING:      'Downloading…',
  COSIGN_DOWNLOAD_ERROR:       'Failed to download the signed offer. Please try again.',
  COSIGN_DECLINE_SUCCESS_TITLE: 'Offer declined',
  COSIGN_DECLINE_SUCCESS_BODY:  'You have declined this offer. The sender has been notified.',
  COSIGN_DECLINE_ERROR:         'Failed to submit your decline. Please try again.',
};
